/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getCustomer = /* GraphQL */ `
  query GetCustomer($id: ID!) {
    getCustomer(id: $id) {
      id
      name
      status
      comments
      createdAt
    }
  }
`;
export const listAllCustomers = /* GraphQL */ `
  query ListAllCustomers {
    listAllCustomers {
      id
      name
      status
      comments
      createdAt
    }
  }
`;
export const listCustomersByStatus = /* GraphQL */ `
  query ListCustomersByStatus($status: Status) {
    listCustomersByStatus(status: $status) {
      id
      name
      status
      comments
      createdAt
    }
  }
`;
